import { inject, injectable } from '@patsnap/tahiti-core/shared/inversify';
import { Site, SLD } from '@patsnap-utils/biz';
import type { PatentLink } from '../link-service';
import { ClientService } from '../../client/client-service';

@injectable()
export class PatentLinkImpl implements PatentLink {
    constructor(
        @inject(ClientService)
        private readonly _clientService: ClientService,
    ) {}

    getPatentLink(patentId: string): string {
        let url = '';
        if (this._clientService.isEureka) {
            url = this._getEurekaViewUrl(patentId);
        } else {
            url = this._getPatentViewUrl(patentId);
        }
        return url;
    }

    private _getPatentViewUrl(patentId: string): string {
        const pathname = `patent-view?patentId=${patentId}`;
        const { href } = new Site({ sld: SLD.ANALYTICS, pathname });
        return href;
    }

    private _getEurekaViewUrl(patentId: string): string {
        const pathname = `view/#?patentId=${patentId}`;
        const { href } = new Site({ sld: SLD.EUREKA, pathname });
        return href;
    }
}
